import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import {
  EMPLOYMENT_VALUES as EMPLOYMENT_TYPE_VALUES,
  UNEMPLOYMENT_REASONS as UNEMPLOYMENT_REASON_VALUES,
} from '@sravni/creditselection-customer-utils/lib/utils/customers';
import { useEffect, useMemo } from 'react';

import type { TWorkplaceFormFields } from 'entities/creditForm';

export const useIsShowWorkFields = () => {
  const { watch, formState, setValue } = useFormContext<TWorkplaceFormFields>();
  const { errors } = formState;

  const employmentType = watch('employmentType.value');
  const unemploymentReason = watch('unemploymentReason.value');
  const isWorkOrganizationManuallyFilled = watch('isWorkOrganizationManuallyFilled');
  const workAddress = watch('workAddress');
  const workOrganizationName = watch('workOrganizationName');

  const hasAnyErrorInSummaryFields = Boolean(
    errors?.employerInn ||
      errors?.workAddress ||
      errors?.areaOfEmployment ||
      errors?.employerType ||
      errors.workLocationRoute,
  );

  useEffect(() => {
    if (hasAnyErrorInSummaryFields) {
      setValue('isWorkOrganizationManuallyFilled', true, { shouldValidate: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAnyErrorInSummaryFields]);

  const isRetired = EMPLOYMENT_TYPE_VALUES.RETIRED === String(employmentType);
  const isNotEmployed = EMPLOYMENT_TYPE_VALUES.NOT_WORKING_VALUE === String(employmentType);
  const isShowJobFields = EMPLOYMENT_TYPE_VALUES.BUSINESS_OWNER !== String(employmentType);
  const isWorkOrganizationNameEmpty = !workOrganizationName;
  const isWorkSummaryAvailable =
    Boolean(workAddress?.value) && !isWorkOrganizationManuallyFilled && !isWorkOrganizationNameEmpty;

  return useMemo(
    () => ({
      isRetired,
      isNotEmployed,
      isWorking: !isRetired && !isNotEmployed,
      isAnotherReason: UNEMPLOYMENT_REASON_VALUES.OTHER === String(unemploymentReason),
      isWorkOrganizationManuallyFilled,
      isWorkSummaryAvailable,
      isShowJobFields,
      isWorkOrganizationNameEmpty,
    }),
    [
      isRetired,
      isNotEmployed,
      unemploymentReason,
      isWorkOrganizationManuallyFilled,
      isWorkSummaryAvailable,
      isShowJobFields,
      isWorkOrganizationNameEmpty,
    ],
  );
};
